import { fork, takeLatest, put, call } from 'redux-saga/effects';
import store from '../store';
import { addModal } from '../actions/modals';
import { CONFIRMATION } from '../actions/confirmation';
import { getStartConfirmation, getFinishConfirmation, saveStartConfirmation, saveFinishConfirmation } from '../utils/Api';

function* sagaGetStartConfirmation({ id }) {
  try {
    const res = yield call(getStartConfirmation, id);
    if (res && res.cycle_id) {
      yield put({ type: CONFIRMATION.LOAD_CONFIRMATION_START_DONE, ...res });
    } else if (res.error && res.error.msg) {
      yield put({ type: CONFIRMATION.LOAD_CONFIRMATION_START_FAILED });
      // console.log(1);
      window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/contents`;
    }
  } catch (message) {
    yield put({ type: CONFIRMATION.LOAD_CONFIRMATION_START_FAILED, message });
    // console.log(2);
    window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
  }
}

function* sagaSaveStartConfirmation({ id, newTab }) {
  try {
    const res = yield call(saveStartConfirmation, id, newTab);
    if (res) {
      yield put({ type: CONFIRMATION.SAVE_CONFIRMATION_START_DONE, ...res });
      // console.log(3);
      const url = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
      window.open(url, newTab ? '_blank' : '_self');
      //window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
    } else if (res.error && res.error.msg) {
      // console.log(4);
      const url = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
      window.open(url, newTab ? '_blank' : '_self');
      //window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
    }
  } catch (message) {
    store.dispatch(addModal(3, [message]));
    // console.log(5);
    const url = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
    window.open(url, newTab ? '_blank' : '_self');
    //window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
  }
}

function* sagaGetFinishConfirmation({ id }) {
  try {
    const res = yield call(getFinishConfirmation, id);
    if (res && res.cycle_id) {
      yield put({ type: CONFIRMATION.LOAD_CONFIRMATION_FINISH_DONE, ...res });
    } else if (res.error && res.error.msg) {
      yield put({ type: CONFIRMATION.LOAD_CONFIRMATION_FINISH_FAILED });
      window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/results`;
    }
  } catch (message) {
    yield put({ type: CONFIRMATION.LOAD_CONFIRMATION_FINISH_FAILED, message });
    window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
  }
}

function* sagaSaveFinishConfirmation({ id, newTab }) {
  try {
    const res = yield call(saveFinishConfirmation, id, newTab);
    if (res) {
      yield put({ type: CONFIRMATION.SAVE_CONFIRMATION_FINISH_DONE, ...res });
      const url = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/results`;
      window.open(url, newTab ? '_blank' : '_self');
      //window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/results`;
    } else if (res.error && res.error.msg) {
      const url = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/results`;
      window.open(url, newTab ? '_blank' : '_self');
      //window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/results`;
    }
  } catch (message) {
    store.dispatch(addModal(3, [message]));
    const url = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
    window.open(url, newTab ? '_blank' : '_self');
    //window.location.href = `${window.location.href.split('/trainings')[0]}/trainings/mytrainings/${id}/lessons`;
  }
}

export default function* startConfirmation() {
  yield [
    fork(function* () {
      yield takeLatest(CONFIRMATION.LOAD_CONFIRMATION_START, sagaGetStartConfirmation);
    }),
    fork(function* () {
      yield takeLatest(CONFIRMATION.SAVE_CONFIRMATION_START, sagaSaveStartConfirmation);
    }),
    fork(function* () {
      yield takeLatest(CONFIRMATION.LOAD_CONFIRMATION_FINISH, sagaGetFinishConfirmation);
    }),
    fork(function* () {
      yield takeLatest(CONFIRMATION.SAVE_CONFIRMATION_FINISH, sagaSaveFinishConfirmation);
    }),
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/confirmation.js